import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import { Button, CardActions } from "@mui/material"
import OPTooltip from "components/material/tooltip"

export default function ImportButton({ connected, funds, importing, toImport, importFunds }) {
  if (!connected || funds.loading || funds.error) {
    return null
  }
  const disabled = isEmpty(toImport) || importing

  let content = <Button disabled={disabled} color="primary" onClick={importFunds}>Start import</Button>
  if (isEmpty(toImport)) {
    content = <OPTooltip title="Please select at least one fund to import.">
      <span>{content}</span>
    </OPTooltip>
  }
  return <CardActions>
    {content}
  </CardActions>
}

ImportButton.propTypes = {
  connected: PropTypes.bool.isRequired,
  funds: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.bool,
  }).isRequired,
  importing: PropTypes.bool.isRequired,
  toImport: PropTypes.array.isRequired,
  importFunds: PropTypes.func.isRequired,
}
